<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="itemEntry.deals"
      :items-per-page="-1"
      hide-default-footer
    >
      <template #item.name="{ item: tempItem }">
        <v-toolbar flat color="transparent" class="broker-detail-toolbar">
          <v-toolbar-title class="body-2">
            <v-btn
              variant="text"
              :to="getAccountRoute({ name: 'deal', params: { id: tempItem._key }})"
            >
              {{ tempItem.name }}
            </v-btn>
          </v-toolbar-title>

          <div class="btn-deal-actions">
            <v-btn class="btn-deal-preview" icon @click="$emit('deal:show', tempItem)">
              <v-icon size="small">mdi-eye</v-icon>
            </v-btn>
            <router-link
              style="text-decoration: none"
              :to="getAccountRoute({ name: 'deal', params: { id: tempItem._key }})"
              target="_blank"
              class="btn-deal-open mr-2"
            >
              <v-btn icon>
                <v-icon size="small">mdi-open-in-new</v-icon>
              </v-btn>
            </router-link>
          </div>
        </v-toolbar>
      </template>
      <template #item.consideration="{ item: tempItem }">
        {{ $filters.formatCurrencyNoDecimal(tempItem.consideration) }}
      </template>
      <template #item.brokerGross="{ item: tempItem }">
        {{ $filters.formatCurrency(tempItem.brokerGross) }}
      </template>
      <template #item.brokerNet="{ item: tempItem }">
        <span v-if="reportTypeEntry !=='gross' ">{{ $filters.formatCurrency(tempItem.brokerNet) }}</span>
      </template>
      <template #item.buildingSize="{ item: tempItem }">
        <BuildingSizeLabel :value="tempItem.buildingSize" />
      </template>
      <template #item.landSize="{ item: tempItem }">
        <LandSizeLabel :value="tempItem.landSize" />
      </template>
      <template #body.append>
        <tr class="sc-data-footer">
          <td style="min-width: 150px" />
          <td class="text-right" style="width: 200px">
            {{ $filters.formatCurrencyNoDecimal(itemEntry.consideration) }}
          </td>
          <td v-if="brokerGrossShowCommission" class="text-right" style="width: 200px">
            {{ $filters.formatCurrency(itemEntry.brokerGross) }}
          </td>
          <td v-if="brokerGrossShowCommission" class="text-right" style="width: 200px">
            <span v-if="reportTypeEntry !== 'gross'">{{ $filters.formatCurrency(itemEntry.brokerNet) }}</span>
          </td>
          <td class="text-right" style="width: 200px">
            <BuildingSizeLabel :value="itemEntry.buildingSize" />
          </td>
          <td class="text-right" style="width: 200px">
            <LandSizeLabel :value="itemEntry.landSize" />
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { IHeader } from '@/bundles/BaseTable/interfaces';
import { AccountLayoutMixin } from '@/bundles/App/mixins/accountMixin';

import LandSizeLabel from '@/bundles/MeasurementUnits/components/LandSizeLabel.vue';
import BuildingSizeLabel from '@/bundles/MeasurementUnits/components/BuildingSizeLabel.vue';

export default defineComponent({
  name: 'BrokerRankingCardDetails',

  components: {
    LandSizeLabel,
    BuildingSizeLabel
  },
  mixins: [AccountLayoutMixin],

  props: {
    itemEntry: {
      type: Object, // TODO: add type
      required: true
    },
    reportTypeEntry: {
      type: String,
      required: true,
    },
    brokerGrossShowCommission: Boolean
  },

  emits: ['deal:show'],

  computed: {
    headers: function (): IHeader[] {
      const headers = [
        { title: 'Deal Name', value: 'name' },
        { title: 'Consideration', value: 'consideration', align: 'end' },
      ];

      if (this.brokerGrossShowCommission) {
        headers.push(
          { title: 'Gross', value: 'brokerGross', align: 'end' },
          { title: 'Net', value: 'brokerNet', align: 'end' },
        );
      }

      headers.push(
        { title: 'Bldg Size', value: 'buildingSize', align: 'end' },
        { title: 'Land Size', value: 'landSize', align: 'end' }
      );

      return headers;
    },
  },
});
</script>
